import { render, staticRenderFns } from "./EditAmount.vue?vue&type=template&id=2a7334a0&"
import script from "./EditAmount.vue?vue&type=script&lang=js&"
export * from "./EditAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports